import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OnboardingFooterText: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID,
    text = ''
}) => (
    <LabelText className={`${className} ${styles.onboardingFooterText}`} testId={testId}>
        {children || text}
    </LabelText>
);

export default OnboardingFooterText;
